<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row justify="center">
          <v-col align="center" cols="6" md="2" class="btn_bg">
            <router-link :to="`/feeds-graph`">
              <v-icon color="#066a8c">mdi-chart-bar</v-icon>
              <div class="mnuBtn">Graphs</div>
            </router-link>
          </v-col>

          <v-col align="center" cols="6" md="2">
            <router-link :to="`/feeds`">
              <v-icon color="#066a8c">mdi-post-outline</v-icon>
              <div class="mnuBtn">Posts Log</div>
            </router-link>
          </v-col>

          <v-col align="center" cols="6" md="2">
            <router-link :to="`/events-log`">
              <v-icon color="#066a8c">mdi-calendar-clock</v-icon>
              <div class="mnuBtn">Activity Log</div>
            </router-link>
          </v-col>
        </v-row>
        <v-row class="ml-1">
          <v-col cols="5" md="5">
            <v-row no-gutters pa-0 ma-0>
              <v-col align="center" cols="6" md="6" v-if="dayClick">
                <div class="pickers mr-6">
                  <v-layout row wrap mt-1>
                    <v-flex xs4>
                      <v-menu
                        v-model="dateMenu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            solo
                            dense
                            class="text1"
                            v-model="date1Formatted"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateDay1"
                          @input="dateMenu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs4 ml-1>
                      <v-menu
                        v-model="dateMenu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="text2"
                            v-model="date2Formatted"
                            solo
                            dense
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateDay2"
                          @input="dateMenu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs2 ml-1>
                      <v-btn dense dark color="#00b0af" @click="callCharts"
                        >Go</v-btn
                      ></v-flex
                    >
                  </v-layout>
                </div>
              </v-col>

              <v-col align="center" cols="6" md="6" v-if="monthClick">
                <div class="pickers mr-6">
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-menu
                        v-model="monthMenu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            solo
                            dense
                            class="text1"
                            v-model="dateMonth1Formatted"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateMonth1"
                          type="month"
                          @input="monthMenu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6>
                      <v-menu
                        v-model="monthMenu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="text2"
                            v-model="dateMonth2Formatted"
                            solo
                            dense
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateMonth2"
                          type="month"
                          @input="monthMenu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </div>
              </v-col>
              <v-col align="center" cols="6" md="6" v-if="yearClick">
                <div class="pickers mr-6">
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-select
                        v-model="dateYear1"
                        :items="getYears"
                        height="27"
                        solo
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        v-model="dateYear2"
                        :items="getYears"
                        height="27"
                        solo
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </div>
              </v-col>
              <!-- <v-btn dense color="#00b0af" @click="callCharts" dark
                >Go</v-btn
              > -->
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            align="center"
            cols="3"
            md="3"
            no-gutters
            style="margin-left:-120px;"
          >
            <v-btn-toggle
              borderless
              dense
              mandatory
              class="date_button_navigation"
              v-model="toggle_mode"
              @change="changeMode"
            >
              <v-btn value="day">Day</v-btn>
              <v-btn value="month">Month</v-btn>
              <v-btn value="year">Year</v-btn>
            </v-btn-toggle>
          </v-col>
          <v-spacer></v-spacer>
          <v-col md="3"></v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <FPBarChart
              v-bind="datas5"
              @chartChangeEvent="chartNavigation"
            ></FPBarChart>
          </v-col>
          <v-col cols="6">
            <FPBarChart
              v-bind="datas6"
              @chartChangeEvent="chartNavigation"
            ></FPBarChart>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <FPBarChart
              v-bind="datas4"
              @chartChangeEvent="chartNavigation"
            ></FPBarChart>
          </v-col>
          <v-col cols="6">
            <FPBarChart
              v-bind="datas2"
              @chartChangeEvent="chartNavigation"
            ></FPBarChart>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="6">
            <FPBarChart
              v-bind="datas1"
              @chartChangeEvent="chartNavigation"
            ></FPBarChart>
          </v-col>
          <v-col cols="6">
            <FPBarChart
              v-bind="datas2"
              @chartChangeEvent="chartNavigation"
            ></FPBarChart>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="12">
            <EventBarChart
              v-bind="eventData"
              @chartChangeEvent="chartNavigation"
            ></EventBarChart>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import FPBarChart from "@/components/charts/FPBarChart";
import EventBarChart from "@/components/charts/EventBarChart";
import moment from "moment";

export default {
  components: {
    FPBarChart,
    EventBarChart,
  },
  data() {
    return {
      toggle_mode: "",
      dateDay1: moment()
        .subtract(10, "days")
        .format("YYYY-MM-DD"),
      dateDay2: moment().format("YYYY-MM-DD"),

      dateMonth1: moment()
        .subtract(6, "months")
        .format("YYYY-MM"),
      dateMonth2: moment().format("YYYY-MM"),

      dateYear1: parseInt(
        moment()
          .subtract(1, "year")
          .format("YYYY")
      ),
      dateYear2: parseInt(moment().format("YYYY")),

      dateMenu1: false,
      dateMenu2: false,
      monthMenu1: false,
      monthMenu2: false,

      dayClick: true,
      monthClick: false,
      yearClick: false,
      // datas1: {
      //   heading: "Events",
      //   type: "allEvents",
      //   fullscreenFlag: true,
      //   yTitle: "Events",
      //   xTitle: "Timeline",
      //   chartData: [],
      //   colors: ["rgb(255, 192, 0)"],
      //   heighest: 0,
      // },
      datas2: {
        heading: "Event Participants",
        type: "eventParticipants",
        fullscreenFlag: true,
        yTitle: "Participants",
        xTitle: "Timeline",
        chartData: [],
        colors: ["rgb(255, 192, 0)"],
        heighest: 0,
      },
      // datas3: {
      //   heading: "Events Per Game",
      //   type: "eventsPerGame",
      //   fullscreenFlag: true,
      //   yTitle: "Events",
      //   xTitle: "Timeline",
      //   chartData: [],
      //   hideDateNavigation: true,
      //   colors: ["rgb(0, 177, 176)"],
      //   heighest: 0,
      //   eventFilter: true,
      // },
      datas4: {
        heading: "Post",
        type: "allPosts",
        fullscreenFlag: true,
        yTitle: "Posts",
        xTitle: "Timeline",
        chartData: [],
        colors: ["rgb(0, 177, 176)"],
        heighest: 0,
      },
      datas5: {
        heading: "Comments",
        type: "allComments",
        fullscreenFlag: true,
        yTitle: "Comments",
        xTitle: "Timeline",
        chartData: [],
        heighest: 0,
      },
      datas6: {
        heading: "Likes",
        type: "allLikes",
        fullscreenFlag: true,
        yTitle: "Likes",
        xTitle: "Timeline",
        chartData: [],
        heighest: 0,
      },
      eventData: {
        heading: "Events",
        type: "events",
        fullscreenFlag: true,
        yTitle: "Events",
        xTitle: "Timeline",
        chartData: [],
        heighest: 0,
        changeID: 0,
        startDate: "",
        endDate: "",
        filterType: "",
      },
    };
  },
  computed: {
    getYears() {
      const currentYear = new Date().getFullYear();
      const range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );
      return range(currentYear, currentYear - 50, -1);
    },
    date1Formatted() {
      return moment(String(this.dateDay1)).format("DD MMM YYYY");
    },
    date2Formatted() {
      return moment(String(this.dateDay2)).format("DD MMM YYYY");
    },
    dateMonth1Formatted() {
      return moment(String(this.dateMonth1)).format("MMMM YYYY");
    },
    dateMonth2Formatted() {
      return moment(String(this.dateMonth2)).format("MMMM YYYY");
    },
  },
  methods: {
    changeMode() {
      if (this.toggle_mode == "day") {
        this.dayClick = true;
        this.monthClick = false;
        this.yearClick = false;
      } else if (this.toggle_mode == "month") {
        this.dayClick = false;
        this.monthClick = true;
        this.yearClick = false;
      } else if (this.toggle_mode == "year") {
        this.dayClick = false;
        this.monthClick = false;
        this.yearClick = true;
      }
      this.callCharts();
    },
    callCharts() {
      let data = { type: this.toggle_mode };
      let eventParams = {
        dateType: this.toggle_mode,
        eventType: "all",
        stackType: "all",
        sports: [],
        reset: true,
      };
      if (this.toggle_mode == "day") {
        data.from = moment(this.dateDay1).format("DD/MM/YYYY");
        data.to = moment(this.dateDay2).format("DD/MM/YYYY");
        eventParams.startDate = this.dateDay1;
        eventParams.endDate = this.dateDay2;
      } else if (this.toggle_mode == "month") {
        data.from = moment(this.dateMonth1).format("MMM-YYYY");
        data.to = moment(this.dateMonth2).format("MMM-YYYY");
        eventParams.startDate = this.dateMonth1;
        eventParams.endDate = this.dateMonth2;
      } else if (this.toggle_mode == "year") {
        data.from = this.dateYear1;
        data.to = this.dateYear2;
        eventParams.startDate = this.dateYear1;
        eventParams.endDate = this.dateYear2;
      }
      // this.allEvents(data);
      this.eventParticipants(data);
      // this.eventsPerGame(data);
      this.allPosts(data);
      this.allComments(data);
      this.allLikes(data);
      this.getEventsGraph(eventParams);
    },
    chartNavigation(data) {
      if (data.chart == "allEvents") {
        this.allEvents(data);
      } else if (data.chart == "eventParticipants") {
        this.eventParticipants(data);
      } else if (data.chart == "eventsPerGame") {
        this.eventsPerGame(data);
      } else if (data.chart == "allPosts") {
        this.allPosts(data);
      } else if (data.chart == "allComments") {
        this.allComments(data);
      } else if (data.chart == "allLikes") {
        this.allLikes(data);
      } else if (data.chart == "events") {
        this.getEventsGraph(data);
      }
    },
    allEvents(data) {
      let url = this.rootUrl;
      let params = {};
      url += "feed-post-total";
      if (data.type == "day") {
        params = {
          "period-type": "dateWiseTotalEvents",
          "start-date": data.from,
          "end-date": data.to,
        };
      } else if (data.type == "month") {
        params = {
          "period-type": "monthWiseTotalEvents",
          "start-month": data.from,
          "end-month": data.to,
        };
      } else if (data.type == "year") {
        params = {
          "period-type": "yearWiseTotalEvents",
          "start-year": data.from,
          "end-year": data.to,
        };
      }

      this.$http
        .post(url, params)
        .then((response) => {
          if (response.status == 200) {
            this.datas1.heighest = this.findHeighestValue(response.data.data);
            this.datas1.chartData = response.data.data;
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    eventParticipants(data) {
      let url = this.rootUrl;
      let params = {};

      url += "admin/feed-post/total-event-participant-count";
      if (data.type == "day") {
        params = {
          "period-type": "dateWiseTotalEventParticipantsCount",
          "start-date": data.from,
          "end-date": data.to,
        };
      } else if (data.type == "month") {
        params = {
          "period-type": "monthWiseTotalEventParticipantsCount",
          "start-month": data.from,
          "end-month": data.to,
        };
      } else if (data.type == "year") {
        params = {
          "period-type": "yearWiseTotalEventParticipantsCount",
          "start-year": data.from,
          "end-year": data.to,
        };
      }

      this.$http
        .post(url, params)
        .then((response) => {
          if (response.status == 200) {
            this.datas2.heighest = this.findHeighestValue(response.data.data);
            this.datas2.chartData = response.data.data;
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    eventsPerGame(data) {
      let url = this.rootUrl;
      let params = {};

      url += "admin/feed-post-total-per-game";
      if (data.type == "day") {
        params = {
          "period-type": "dateWiseEventsrCountPerGame",
          "start-date": data.from,
          "end-date": data.to,
        };
      } else if (data.type == "month") {
        params = {
          "period-type": "monthWiseEventsrCountPerGame",
          "start-month": data.from,
          "end-month": data.to,
        };
      } else if (data.type == "year") {
        params = {
          "period-type": "yearWiseEventsrCountPerGame",
          "start-year": data.from,
          "end-year": data.to,
        };
      }
      this.$http
        .post(url, params)
        .then((response) => {
          if (response.status == 200) {
            this.datas3.heighest = this.findHeighestValue(
              JSON.parse(response.data.data)
            );
            this.datas3.chartData = JSON.parse(response.data.data);
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    allPosts(data) {
      let url = this.rootUrl;
      let params = {};

      url += "admin/feed-post-total-post-count";
      if (data.type == "day") {
        params = {
          "period-type": "dateWiseTotalPostCount",
          "start-date": data.from,
          "end-date": data.to,
        };
      } else if (data.type == "month") {
        params = {
          "period-type": "monthWiseTotalPostCount",
          "start-month": data.from,
          "end-month": data.to,
        };
      } else if (data.type == "year") {
        params = {
          "period-type": "yearWiseTotalPostCount",
          "start-year": data.from,
          "end-year": data.to,
        };
      }
      this.$http
        .post(url, params)
        .then((response) => {
          if (response.status == 200) {
            this.datas4.heighest = this.findHeighestValue(response.data.data);
            this.datas4.chartData = response.data.data;
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    allComments(data) {
      let url = this.rootUrl;
      let params = {};

      url += "admin/feed-post/total-comments-count";
      if (data.type == "day") {
        params = {
          "period-type": "dateWiseTotalCommentsCount",
          "start-date": data.from,
          "end-date": data.to,
        };
      } else if (data.type == "month") {
        params = {
          "period-type": "monthWiseTotalCommentsCount",
          "start-month": data.from,
          "end-month": data.to,
        };
      } else if (data.type == "year") {
        params = {
          "period-type": "yearWiseTotalCommentsCount",
          "start-year": data.from,
          "end-year": data.to,
        };
      }

      this.$http
        .post(url, params)
        .then((response) => {
          if (response.status == 200) {
            this.datas5.heighest = this.findHeighestValue(response.data.data);
            this.datas5.chartData = response.data.data;
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    allLikes(data) {
      let url = this.rootUrl;
      let params = {};

      url += "admin/feed-post/total-likes-count";
      if (data.type == "day") {
        params = {
          "period-type": "dateWiseTotalLikesCount",
          "start-date": data.from,
          "end-date": data.to,
        };
      } else if (data.type == "month") {
        params = {
          "period-type": "monthWiseTotalLikesCount",
          "start-month": data.from,
          "end-month": data.to,
        };
      } else if (data.type == "year") {
        params = {
          "period-type": "yearWiseTotalLikesCount",
          "start-year": data.from,
          "end-year": data.to,
        };
      }
      this.$http
        .post(url, params)
        .then((response) => {
          if (response.status == 200) {
            this.datas6.heighest = this.findHeighestValue(response.data.data);
            this.datas6.chartData = response.data.data;
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    getEventsGraph(params) {
      this.$http
        .post(this.rootUrl + "admin/feed-post/event", params)
        .then((response) => {
          if (response.status == 200) {
            var data = response.data.data;
            var graphData = [];
            let keys = Object.keys(data[0]).filter(
              (ele) => ele.toLowerCase() != "date"
            );
            let keysLength = keys.length;
            let largest = 0;
            data.forEach((element, index) => {
              let di = 0;
              let lar = 0;
              for (let i = 0; i < keysLength; i++) {
                if (index == 0) {
                  graphData[i] = {};
                  graphData[i].data = {};
                  graphData[i].name = keys[i];
                  lar = lar + parseInt(element[keys[i]]);
                  graphData[i].data[element.Date] = element[keys[i]];
                  graphData[keysLength] = {};
                  graphData[keysLength].name = "Total";
                  graphData[keysLength].data = {};
                  graphData[keysLength].data[element.Date] = 0;
                  di = di + 1;
                } else {
                  lar = lar + parseInt(element[keys[i]]);
                  graphData[i].data[element.Date] = element[keys[i]];
                  di = di + 1;
                }
              }
              graphData[keysLength].data[element.Date] = 0;
              if (largest < lar) {
                largest = lar;
              }
            });
            if (keysLength == 1 && keys[0] == "Events") {
              graphData[0].library = {};
              graphData[0].library.datalabels = {
                color: "rgba(0,0,49)",
                align: "end",
                anchor: "end",
                font: {
                  size: 12,
                  weight: 700,
                },
              };
            }
            if (params.stackType != "all") {
              graphData[keysLength].library = {};
              graphData[keysLength].library.datalabels = {
                color: "rgba(0,0,49)",
                formatter: (value, ctx) => {
                  return ctx.chart.$totalizer.totals[ctx.dataIndex];
                },
                font: {
                  size: 12,
                  weight: 700,
                },
                align: "end",
                anchor: "end",
                display: function(ctx) {
                  return (
                    ctx.datasetIndex === ctx.chart.$totalizer.utmost &&
                    ctx.chart.$totalizer.totals[ctx.dataIndex] !== 0
                  );
                },
              };
            }
            // let heading =
            //   this.type == null || this.type == "all"
            //     ? ""
            //     : this.type.charAt(0).toUpperCase() + this.type.slice(1) + " ";
            // heading += "Sales";
            // heading +=
            //   this.tag.length == this.tags.length
            //     ? ""
            //     : " - " +
            //       this.tags
            //         .filter((tag) => this.tag.includes(tag.id))
            //         .map((val) => val.name)
            //         .join(", ");

            // this.eventData.heading = heading;
            this.eventData.heighest = Math.ceil(largest * 1.1);
            this.eventData.chartData = graphData;
            this.eventData.exportData = data;
            this.eventData.startDate = String(params.startDate);
            this.eventData.endDate = String(params.endDate);
            this.eventData.filterType = params.dateType;
            if (params.reset == true) {
              this.eventData.changeID += 1;
            }
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    findHeighestValue(data) {
      var largest = 0;
      data.forEach(function(arr) {
        if (typeof arr[1] != "undefined") {
          if (arr[1] > largest) {
            largest = arr[1];
          }
        } else {
          var obj = arr.data;
          let lvalue = Object.values(obj).reduce(function(a, b) {
            return a > b ? a : b;
          });
          if (lvalue > largest) largest = lvalue;
        }
      });
      return Math.ceil(largest * 1.1);
    },
  },
};
</script>
<style scoped>
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
.mnuBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #066a8c;
}
.date_button_navigation {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.date_button_navigation .v-item--active {
  background-color: #062b48 !important;
  color: #fff !important;
}
</style>
